module.exports = __webpack_public_path__ + "img/BoD_02_Dr_Ang_Seng_Bin.656ae5a3.jpg";